import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import VueGoogleMaps from '@fawmi/vue-google-maps'

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - Gugar CRM` : 'Gugar CRM',
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(VueGoogleMaps, {
        load: {
          key: 'AIzaSyDQitbi4RV9vRM-Oh1MyDi5-jDnNlIqLNY',
          libraries: "visualization"
        },
      })
      .mount(el)
  },
})
